<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <info-card :data-item="dataItem" />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <rating-card :data-item="dataItem" />
          </b-col>
        </b-row>
      </b-card>
      <item-form />
    </b-col>
  </b-row>
</template>
<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import InfoCard from '@/views/Feedbacks/View/InfoCard.vue'
import RatingCard from '@/views/Feedbacks/View/RatingCard.vue'
import ItemForm from '@/views/Feedbacks/ItemForm.vue'

export default {
  name: 'View',
  components: {
    BCard,
    BRow,
    BCol,
    InfoCard,
    RatingCard,
    ItemForm,
  },
  computed: {
    dataItem() {
      return this.$store.getters['feedbacks/dataItem']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('feedbacks/getDataItem', this.$route.params.id)
      this.$store.dispatch('feedbackNotes/getDataList', this.$route.params.id)
    },
  },
}
</script>
